import { observer } from "mobx-react-lite";
import { FC, PropsWithChildren } from "react";
import { DebugModeTapDetector } from "@/components/layout/components/account-profile/DebugModeTapDetector";
import { MDSText } from "@/mds";
import styled from "@emotion/styled";
import { MDSLoadingIcon, MDSLoadingIconSize } from "@/mds/components/loading-icon";
import { mdsBreakpoints } from "@/design-system/foundations";
import { useMediaQuery } from "usehooks-ts";

export const AuthCardBase: FC<PropsWithChildren> = observer(({ children }) => {
  const isDesktop = useMediaQuery(mdsBreakpoints().desktop);
  return (
    <Wrapper>
      <DebugModeTapDetector>
        <MDSLoadingIcon
          size={isDesktop ? MDSLoadingIconSize.Large : MDSLoadingIconSize.Medium}
          loop={false}
        />
      </DebugModeTapDetector>
      <StyledTitle>One place for everything on your mind</StyledTitle>
      <StyledContainer>{children}</StyledContainer>
    </Wrapper>
  );
});

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-inline: 24px;
  gap: ${({ theme }) => theme.spacing[4]};
  -webkit-app-region: no-drag;

  @media (${mdsBreakpoints().desktop}) {
    padding-inline: 48px;
  }
`;

const StyledTitle = styled(MDSText)`
  color: ${({ theme }) => theme.colors.text.contrast};
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.672px;
  max-width: 400px;

  @media (${mdsBreakpoints().desktop}) {
    font-size: 42px;
  }
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]};
  padding-top: ${({ theme }) => theme.spacing[4]};
  width: 100%;
`;
